import React, { useState } from "react";
import "./Styles.css";
import { Button } from '@mui/material';
import { Forms } from "./forms";
import { AIObjects } from "./ai_objects";
import { useParams, Link } from "react-router-dom";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import {SaveAlert} from "./save_alerts";
import ApiConfig from '../../../utils/services/apiConfig'
import { useKeycloak } from '@react-keycloak/web';
import { useMountEffect } from '../../../utils/hooks';

function AIComponent(props) {
  const { name } = useParams();
  // const { aiobjects, robotSelectedEp, onFetchEndpoints, onFetchAssignedEndpoints } = location.state || {};
  const [robot, setRobot] = useState({})
  const [aiobjects, setAIObjects] = useState([]);
  const [openForm, setOpenForm] = useState(false);
  const [editAIObject, setEditAIObject] = useState(null);
  const [selectedAIObject, setSelectedAIObject] = useState([]); // array of selected ep names
  const [submitAlert, setSubmitAlert] = useState(null);
  // const [broadcastMessages, setBroadcastMessages] = useState([]);
  // const [screenDisplays, setScreenDisplays] = useState([]);
  const { keycloak } = useKeycloak();
  const a = new ApiConfig(keycloak)
  const apiConfig = a.api()

  const initRetrieve = () => {
    Promise.all([
        apiConfig.fetchAllAIObjects(),
        apiConfig.fetchRobotData(0),
        apiConfig.fetchAllAIConfigs(),
        // apiConfig.fetchAllAIBroadcasts(),
        // apiConfig.fetchAllAIScreenDisplays()
    ]).then(results => {
        setAIObjects(results[0].RobotResponse);
        var currentRobot = {}
        for(let i = 0; i < results[1].RobotResponse.length; i++) {
          if(results[1].RobotResponse[i].RobotId === name){
              setRobot(results[1].RobotResponse[i])
              currentRobot = results[1].RobotResponse[i]
              break;
          }
        }
        const formattedSelectedAIObjects = [];
        results[2].RobotResponse.forEach(item => {
            if (String(item.RobotTableId) === String(currentRobot.Id)){
              var robotAIObject = null
              results[0].RobotResponse.forEach(AIObject => {
                if(String(AIObject.Id) === String(item.RobotAIObjectId)){
                  robotAIObject = AIObject
                }
              });
              formattedSelectedAIObjects.push(robotAIObject);
            }
        });
        setSelectedAIObject(formattedSelectedAIObjects);
        // setBroadcastMessages(results[3].RobotResponse);
        // setScreenDisplays(results[4].RobotResponse);
    }).catch(error => {
        console.error(error);
    });
  }

  useMountEffect(() => {
    initRetrieve()
  }, []);

  const handleSubmitYes = (newData) => {
    // if edit ep button is clicked
    if (editAIObject) {
      Promise.all([
          apiConfig.updateAIObject(editAIObject.Id, newData),
      ]).then(results => {
        setEditAIObject(null);
        setOpenForm(false);
        initRetrieve()
      }).catch(error => {
          console.error(error);
      });

    }
    // if adding new aiobject button is clicked
    else {
      Promise.all([
        apiConfig.createAIObject(newData),
      ]).then(results => {
        setOpenForm(false);
        initRetrieve()
      }).catch(error => {
          console.error(error);
      });
      // setOpenForm(false);
    }
    console.log("Reinit")
    setSubmitAlert(null)
  };

  const handleSelectedAIObject = (aiobject) => {
    // if ep in selectedAIObject then remove it, else include it
    console.log(aiobject);
    const updatedSelectedAIObject = selectedAIObject.includes(aiobject)
      ? selectedAIObject.filter((aiob) => aiob !== aiobject)
      : [...selectedAIObject, aiobject];
    // console.log(updatedSelectedEp)
    setSelectedAIObject(updatedSelectedAIObject);
  };

  const handleEditAIObject = (aiobject) => {
    setEditAIObject(aiobject); // changing selected Ep, calls form w new eachEntry
    setOpenForm(true);
  };

  const handleDeleteAIObject = (aiobjectId) => {
    Promise.all([
      apiConfig.deleteAIObject(aiobjectId),
    ]).then(results => {
      initRetrieve()
    }).catch(error => {
        console.error(error);
    });
  };

  const handleCreateAIConfig = (aiConfigs) => {
    Promise.all([
      apiConfig.deleteAIConfigByRobotTableId({robot_table_id: robot.Id}),
    ]).then(results => {
      // console.log(results[0].RobotResponse)
      aiConfigs.forEach(aiobject=>{
        apiConfig.createAIConfig({RobotTableId: robot.Id, RobotAIObjectId: aiobject.Id, CreatedBy: "system", UpdatedBy: "system", Active: true}).then(result=>{
          // console.log(result.RobotResponse)
          initRetrieve()
        })
      })
    }).catch(error => {
        console.error(error);
    });
  };

  const handleCancelForm = () => {
    setEditAIObject(null);
    setOpenForm(false);
  }

  const submit = (newData) => {
    setSubmitAlert(newData);
  }

  return (
    <div className="epContainer">
      <div className="TopParts">
        <Button component={Link} to={`/managements/ai_management`} variant="contained" className="backButton">
            Back to Robots
        </Button>
        <hr style={{width: '100%',marginTop: '1%' }}/>
        <div className="top">
          <h1>AI Objects for Robot {name}</h1>
          <Button onClick={(e) => {setOpenForm(true);setEditAIObject(null);}}
          style={{ borderRadius: 10 , fontSize: "1.5rem", padding: "6px 18px",
          color: "white", backgroundColor: "rgb(55, 99, 221)"}}
          variant="contained"
          startIcon={<AddCircleOutlineIcon style={{ fontSize: 30}}/>}>
            Add New AI Object
          </Button>
        </div>
      </div>

        <AIObjects
          apiConfig={apiConfig}
          aiobjects = {aiobjects}
          onEditAIobject={handleEditAIObject}
          selectedAIObject={selectedAIObject}
          onSelectAIObject={handleSelectedAIObject}
          onDeleteAIObject={handleDeleteAIObject}
          onCreateAIConfig={handleCreateAIConfig}
        />

        {submitAlert && <SaveAlert onClose={() => {setSubmitAlert(null);}} onYes={() => handleSubmitYes(submitAlert)} heading={"Confirm Submission?"} message={null}/>}
        {openForm && <Forms apiConfig={apiConfig} onSubmit={submit} onCancel={handleCancelForm} editAIObject={editAIObject} aiobjects={aiobjects}/>}

    </div>
  );
}

export default AIComponent;
